import React from 'react';
import { Box, Typography, Avatar, Stack, styled, alpha } from '@mui/material';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { getMediaUrl } from '../../../utils/urlHelper';
import { GlassCard } from '../../StyledComponents/StyledComponent';

const HeaderContainer = styled(GlassCard)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '32px',
    marginBottom: '24px',
    background: theme.palette.mode === 'dark' 
        ? alpha('#1e293b', 0.6) 
        : alpha('#ffffff', 0.7),
}));

const ProfileSection = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
});

const PhotoWrapper = styled(Box)({
    position: 'relative',
    '&:hover .upload-overlay': {
        opacity: 1,
    },
});

const UploadOverlay = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    backgroundColor: alpha('#000', 0.4),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    opacity: 0,
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    backdropFilter: 'blur(2px)',
}));

const ProfileHeader = ({ employee, onPhotoUpload, children }) => {
    const photoUrl = getMediaUrl(employee?.photo);

    return (
        <HeaderContainer>
            <ProfileSection>
                <PhotoWrapper>
                    <Avatar
                        src={photoUrl}
                        sx={{ 
                            width: 110, 
                            height: 110, 
                            fontSize: '40px', 
                            bgcolor: alpha('#3DAC5A', 0.1),
                            color: '#3DAC5A',
                            border: `4px solid #fff`,
                            boxShadow: `0 8px 16px ${alpha('#000', 0.08)}`
                        }}
                    >
                        {employee?.name?.[0]}
                    </Avatar>
                    <UploadOverlay className="upload-overlay" onClick={() => document.getElementById('photo-input').click()}>
                        <PhotoCameraIcon />
                    </UploadOverlay>
                    <input
                        type="file"
                        id="photo-input"
                        hidden
                        accept="image/*"
                        onChange={(e) => onPhotoUpload(e.target.files[0])}
                    />
                </PhotoWrapper>
                <Box>
                    <Typography variant="h4" sx={{ fontWeight: 800, color: '#1e293b', letterSpacing: '-0.02em', mb: 0.5 }}>
                        {employee?.name || 'Employee Name'}
                    </Typography>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography variant="body1" sx={{ color: '#64748b', fontWeight: 600 }}>
                            {employee?.designation || 'Designation'}
                        </Typography>
                        <Box sx={{ width: 4, height: 4, borderRadius: '50%', bgcolor: '#cbd5e1' }} />
                        <Typography variant="body1" sx={{ color: '#3DAC5A', fontWeight: 700 }}>
                            {employee?.employee_no || 'EMP-000'}
                        </Typography>
                    </Stack>
                </Box>
            </ProfileSection>

            <Box>
                {children}
            </Box>
        </HeaderContainer>
    );
};

export default ProfileHeader;
